export default __webpack_public_path__ + "static/media/NotoSans-Italic.4e7f010e.ttf";